import { Box, Typography, Link } from '@mui/material'
import { styled } from '@mui/material/styles'

export const FooterWrapper = styled(Box)<{ component?: React.ElementType }>(({ theme }) => ({
    marginTop: 'auto',
    backgroundColor: theme.palette.background.paper,
    // Simple responsive padding
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}))

export const FooterContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
}))

export const FooterLink = styled(Link)(({ theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    color: theme.palette.text.secondary,
    fontSize: 14,
    '& svg': {
        fontSize: 18,
    },
    '&:hover': {
        color: theme.palette.text.primary,
    },
}))

export const FooterSeparator = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
}))

export const FooterText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: 14,
    textAlign: 'center',
}))
